<div id="app-main" class="app-main">
    <div class="app-menu">
        <app-menu>
        </app-menu>
    </div>
    <div
        class="app-overlay"
        (click)="toggleMenu()"
    ></div>
    <div class="app-app">
        <div class="app">
            <app-header [isLogin]="isLoggedIn" [userRol]="currentRole" ></app-header>
            <router-outlet></router-outlet>
            <app-footer></app-footer>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalCompartir" tabindex="-1" aria-labelledby="modalCompartirLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalCompartirLabel">Compartir</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <p class="text-left">
                    Seleccione el medio por el cual desea compartir el link:
                </p>
                <div class="row">
                    <div class="col-6 text-center">
                        <a href="javascript:void(0);" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3" title="Correo electrónico">
                            <i class="fa-regular fa-envelope fa-3x"></i>
                            Correo electrónico
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a href="javascript:void(0);" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3" title="Facebook">
                            <i class="fa-brands fa-facebook fa-3x"></i>
                            Facebook
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a href="javascript:void(0);" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3" title="Instagram">
                            <i class="fa-brands fa-instagram fa-3x"></i>
                            Instagram
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a href="javascript:void(0);" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3" title="X">
                            <i class="fa-brands fa-x-twitter fa-3x"></i>
                            X
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a href="javascript:void(0);" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3" title="Whatsapp">
                            <i class="fa-brands fa-whatsapp fa-3x"></i>
                            Whatsapp
                        </a>
                    </div>
                    <div class="col-6 text-center">
                        <a href="javascript:void(0);" class="btn btn-primary d-flex flex-column justify-content-center mb-3 py-3" title="Telegram">
                            <i class="fa-brands fa-telegram fa-3x"></i>
                            Telegram
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>